<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class="card-form"
    [formGroup]="motorForm"
    (ngSubmit)="submitForm()"
    novalidate
  >
    <div class="blue-top"></div>
    <div class="card-section top-section" *ngIf="claim !== 'theft'">
      <!-- only renders if claim isn't theft -->
      <h1>
        <b>{{ pageHeading }}</b>
      </h1>
      <h2>{{ driverDetailsHeading }}</h2>

      <p>{{ driverQuestion }}</p>
      <section formGroupName="driver" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="isOwner" (change)="onOwnerChange()">
              {{ownerLabel}}
            </mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="isElseOne" (change)="onElseOneChange()">
              {{ someoneLabel }}
            </mat-checkbox>
          </div>
        </div>
        <mat-error *ngIf="formGroupErrors['driver']" style="padding-left: 5px;">
          {{formGroupErrors["driver"]}}
        </mat-error>
      </section>


      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          fullNameLabel
        }}</mat-label>
        <input matInput formControlName="fullName" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['fullName']">{{
          formErrors["fullName"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        *ngIf="additionalInfo === false"
      >
        <mat-label class="form-select-placeholder-unselected">{{
          addressLabel
        }}</mat-label>
        <mat-hint *ngIf="motorForm.controls['driver'].controls['isElseOne'].value === true">{{ otherDriverAdHint }}</mat-hint>
        <input matInput formControlName="address" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['address']">{{
          formErrors["address"]
        }}</mat-error>
      </mat-form-field>

      <!-- <mat-form-field
        appearance="outline"
        class="form-select"
        *ngIf="additionalInfo === false"
      >
        <mat-label class="form-select-placeholder-unselected">{{
          licenceLabel
        }}</mat-label>
        <mat-hint *ngIf="motorForm.controls['driver'].controls['isElseOne'].value === true">{{ otherDriverLiceHint }}</mat-hint>
        <input matInput formControlName="licenseNumber" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['licenseNumber']">{{
          formErrors["licenseNumber"]
        }}</mat-error>
      </mat-form-field> -->

      <!-- <mat-form-field
        appearance="outline"
        class="form-select"
        appFullYearDateFormat
        *ngIf="additionalInfo === false"
      >
        <mat-label class="form-select-placeholder-unselected">{{
          dateIssueLabel
        }}</mat-label>
        <input
          matInput
          [min]="minIssueDate"
          [max]="maxIssueDate"
          [matDatepicker]="picker"
          readonly="true"
          (click)="picker.open()"
          formControlName="dateIssue"
          (blur)="logErrors()"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker> </mat-datepicker>
        <mat-error *ngIf="formErrors['dateIssue']">{{
          formErrors["dateIssue"]
        }}</mat-error>
      </mat-form-field> -->

      <p
        *ngIf="
          additionalInfo === false &&
          motorForm.controls['driver'].controls['isElseOne'].value === true
        "
      >
        {{ authorityQuestion }}
      </p>
      <section formGroupName="driverAuthorized" style="margin-bottom: 15px;"
        *ngIf="
          additionalInfo === false &&
          motorForm.controls['driver'].controls['isElseOne'].value === true
        "
      >
        <div class="row-div modified_checkbox">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYesChange()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNoChange()">{{
              noText
            }}</mat-checkbox>
          </div>
          
        </div>

        <mat-error
        *ngIf="
          motorForm.get('driver.isElseOne')!.value === true
          && !formGroupErrors['driver']
          && formGroupErrors['driverAuthorized']
        ">
        {{ formGroupErrors["driverAuthorized"] }}</mat-error>
      </section>
      
      <!-- owner etc aditional info form -->
      <mat-form-field
        appearance="outline"
        class="form-select"
        *ngIf="additionalInfo === true"
      >
        <mat-label class="form-select-placeholder-unselected">{{
          idNumLabel
        }}</mat-label>
        <input matInput type="text" maxlength="9" formControlName="idNum" (blur)="logErrors()"/>
        <mat-error *ngIf="formErrors['idNum']">{{formErrors['idNum']}}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        *ngIf="additionalInfo === true"
      >
        <mat-label class="form-select-placeholder-unselected">{{kraNumLabel}}</mat-label>
        <input matInput type="text" maxlength="11" spellcheck="false" formControlName="kraPin" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['kraPin']">{{formErrors["kraPin"]}}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        *ngIf="additionalInfo === true"
      >
        <mat-label class="form-select-placeholder-unselected">{{
          telLabel
        }}</mat-label>
        <input matInput type="tel" formControlName="tel" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['tel']">{{formErrors['tel']}}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        appFullYearDateFormat
        *ngIf="additionalInfo === true"
      >
        <mat-label class="form-select-placeholder-unselected">{{
          dobLabel
        }}</mat-label>
        <input
          matInput
          [min]="minDobDate"
          [max]="maxDobDate"
          [matDatepicker]="pickerX"
          readonly="true"
          (click)="pickerX.open()"
          formControlName="dob"
          (blur)="logErrors()"
        />
        <mat-error *ngIf="formErrors['dob']">{{formErrors['dob']}}</mat-error>
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerX"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerX> </mat-datepicker>
      </mat-form-field>

      <div
        class="row-div margin-top-30"
        *ngIf="
          additionalInfo === true &&
          motorForm.controls['driver'].controls['isElseOne'].value === false
        "
      >
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{ cancelText }}</span>
        </button>
        <button mat-button type="submit" [disabled]="!motorForm.valid">
          <span class="button-text">{{ saveText }}</span>
        </button>
      </div>
    </div>

    <div class="card-section top-section" *ngIf="claim === 'theft'">
      <h1>
        <b>{{ pageHeading }}</b>
      </h1>
      <h2>{{ driverDetailsHeading }}</h2>
      <p>{{ thiefSubheading }}</p>

      <p>{{ driverQuestion }}</p>
      <section formGroupName="drivingDuringTheft" style="margin-bottom: 15px;" >
        <div class="row-div modified_checkbox">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox
              formControlName="yes"
              (change)="onTheftYesDrivingChange()"
              >{{ yesText }}</mat-checkbox
            >
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox
              formControlName="no"
              (change)="onTheftNoDrivingChange()"
              >{{ noText }}</mat-checkbox
            >
          </div>
        </div>

        <mat-error
          *ngIf="formGroupErrors['drivingDuringTheft']">
          {{formGroupErrors["drivingDuringTheft"]}}
        </mat-error>
      </section>

      <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 17px;">
        <mat-label class="form-select-placeholder-unselected">{{
          fullNameLabel
        }}</mat-label>
        <!-- <mat-hint>{{ driverNameHint }}</mat-hint> -->
        <input matInput formControlName="fullName" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['fullName']">{{
          formErrors["fullName"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 17px;">
        <mat-label class="form-select-placeholder-unselected">{{
          idNumLabel
        }}</mat-label>
        <!-- <mat-hint>{{ driverIDHint }}</mat-hint> -->
        <input matInput type="text" maxlength="9" formControlName="idNum" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['idNum']">{{
          formErrors["idNum"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select" style="margin-bottom: 17px;">
        <mat-label class="form-select-placeholder-unselected">{{
          addressLabel
        }}</mat-label>
        <!-- <mat-hint>{{ otherDriverAdHint }}</mat-hint> -->
        <input matInput formControlName="address" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['address']">{{
          formErrors["address"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          telLabel
        }}</mat-label>
        <!-- <mat-hint>{{ driverPhoneHint }}</mat-hint> -->
        <input matInput type="tel" formControlName="tel" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['tel']">{{ formErrors["tel"] }}</mat-error>
      </mat-form-field>
    </div>

    <div class="card-section bottom-section" *ngIf="additionalInfo === false">
      <h2>{{ secondSubHeading }}</h2>

      <mat-form-field
        appearance="outline"
        class="form-select"
        appFullYearDateFormat
      >
        <mat-label class="form-select-placeholder-unselected">{{
          accidentDateLabel
        }}</mat-label>
        <input
          matInput
          [min]="minLossDate"
          [max]="maxDate"
          [matDatepicker]="picker2"
          readonly="true"
          (click)="picker2.open()"
          formControlName="eventDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker2> </mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          accidentTimeLabel
        }}</mat-label>
        <input matInput type="time" formControlName="eventTime" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['eventTime']">{{
          formErrors["eventTime"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          accidentLocationLabel
        }}</mat-label>
        <input matInput formControlName="location" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['location']">{{
          formErrors["location"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        *ngIf="altView === true"
      >
        <mat-label class="form-select-placeholder-unselected">{{
          personInChargeLabel
        }}</mat-label>
        <input matInput formControlName="personInCharge" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['personInCharge']">{{
          formErrors["personInCharge"]
        }}</mat-error>
      </mat-form-field>

      <p
        *ngIf="
          claim === 'theft' &&
          motorForm.controls['drivingDuringTheft'].controls['yes'].value ===
            true
        "
      >
        {{ authorityQuestion }}
      </p>
      <section formGroupName="driverAuthorized" style="margin-bottom: 15px;"
        *ngIf="
          claim === 'theft' &&
          motorForm.controls['drivingDuringTheft'].controls['yes'].value === true  " >
        <div class="row-div modified_checkbox">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYesChange()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNoChange()">{{
              noText
            }}</mat-checkbox>
          </div>

        </div>

        <mat-error
          *ngIf="
            motorForm.get('drivingDuringTheft.yes')!.value === true
            && !formGroupErrors['drivingDuringTheft']
            && formGroupErrors['driverAuthorized']">
          {{ formGroupErrors["driverAuthorized"] }}
        </mat-error>
      </section>

      <p *ngIf="altView === true">{{ securelyLockedQuestion }}</p>
      <section formGroupName="doorsLocked" *ngIf="altView === true" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes2Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo2Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </div>

        <mat-error *ngIf="formGroupErrors['doorsLocked']">
          {{formGroupErrors["doorsLocked"]}}
        </mat-error>
      </section>

      <p *ngIf="altView === true">{{ windowsClosedQuestion }}</p>
      <section formGroupName="windowsClosed" *ngIf="altView === true" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes3Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo3Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </div>
        <mat-error *ngIf="formGroupErrors['windowsClosed']">
          {{ formGroupErrors["windowsClosed"] }}
        </mat-error>
      </section>

      <p *ngIf="altView === true">{{ antiTheftDeviceQuestion }}</p>
      <section formGroupName="antiTheftFitted" *ngIf="altView === true" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes4Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo4Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </div>

        <mat-error *ngIf="formGroupErrors['antiTheftFitted']">
          {{ formGroupErrors["antiTheftFitted"] }}
        </mat-error>
      </section>

      <p *ngIf=" altView === true &&
          motorForm.controls['antiTheftFitted'].controls['yes'].value === true ">
        {{ selectAntitheftTextLabel }}
      </p>

      <section class="modified_checkbox" formGroupName="antiTheft" style="margin-bottom: 15px;"
        *ngIf="
          altView === true &&
          motorForm.controls['antiTheftFitted'].controls['yes'].value === true
        "
      >
        <div class="row-div">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="trackingDevice">{{
              trackingDeviceText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="carAlarm">{{
              carAlarmText
            }}</mat-checkbox>
          </div>
        </div>
        <div class="row-div">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="cutOff">{{
              cutOffText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="gearLock">{{
              gearLockText
            }}</mat-checkbox>
          </div>
        </div>

        <mat-error *ngIf="motorForm.get('antiTheftFitted.yes')!.value === true && formGroupErrors['antiTheft']">
          {{formGroupErrors["antiTheft"]}}
        </mat-error>
      </section>

      <!-- 
            <mat-form-field appearance="outline" class="form-select" *ngIf="altView === true && motorForm.controls['antiTheftFitted'].controls['yes4'].value === true">
                <mat-label class="form-select-placeholder-unselected">
                    {{selectAntitheftLabel}}
                </mat-label>
                <mat-select formControlName="antiTheftType"  panelClass="form-select-popup">
                    <mat-option class="form-option" [value]="antiTheftPlaceHolder" *ngFor="let antiTheftPlaceHolder of AntiTheftPlaceHolders">
                        {{antiTheftPlaceHolder}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
             -->

      <mat-form-field
        appearance="outline"
        class="form-select"
        floatLabel="always"
        *ngIf="altView === true"
      >
        <mat-label class="form-select-placeholder-unselected">{{'Details of loss'}}</mat-label>
        <textarea matInput formControlName="lossExplanation" placeholder="{{ lossInfoLabel }}" style="height: 70px;" (blur)="logErrors()"></textarea>
        <mat-error *ngIf="formErrors['lossExplanation']">{{
          formErrors["lossExplanation"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        floatLabel="always"
        *ngIf="claim !== 'theft'"
      >
        <mat-label class="form-select-placeholder-unselected">
          {{'Purpose for use during occurrence'}}
        </mat-label>
        <textarea matInput
          placeholder="{{ purposeQuestionLabel }}"
          formControlName="purposeExplanation"
          (blur)="logErrors()"
          style="height: 70px;">
        </textarea>
        <mat-error *ngIf="formErrors['purposeExplanation']">{{
          formErrors["purposeExplanation"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        floatLabel="always"
        *ngIf="altView === false"
      >
        <mat-label class="form-select-placeholder-unselected">{{'Damage Details'}}</mat-label>
        <textarea matInput
          placeholder="{{ damageInfoLabel }}"
          formControlName="damageExplanation"
          (blur)="logErrors()"
          style="height: 70px;" >
        </textarea>
        <mat-error *ngIf="!altView && formErrors['damageExplanation']">{{
          formErrors["damageExplanation"]
        }}</mat-error>
      </mat-form-field>

      <div
        class="row-div margin-top-50 margin-bottom-40"
        *ngIf="altView === false"
      >
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{ cancelText }}</span>
        </button>
        <button mat-button type="submit" [disabled]="!motorForm.valid">
          <span class="button-text">{{ saveText }}</span>
        </button>
      </div>
    </div>

    <!-- Entertainment / Theft, Third card {Particulars of Loss} -->
    <div class="card-section bottom-section" *ngIf="additionalInfo === false && altView === true" >
      <h2>{{ particularsLossSubheading }}</h2>

      <div class="width-100pc" *ngIf="claim === 'entertainment'">
        <p>{{ stolenQuestion }}</p>
        <section
          class="row-div modified_checkbox"
          formGroupName="stolenOrDamaged"
        >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox
              formControlName="stolen"
              (change)="onStolenChange()"
              >{{ stolenText }}</mat-checkbox
            >
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox
              formControlName="damaged"
              (change)="onDamagedChange()"
              >{{ damagedText }}</mat-checkbox
            >
          </div>
        </section>
        <mat-error *ngIf="formGroupErrors['stolenOrDamaged']">{{
          formGroupErrors["stolenOrDamaged"]
        }}</mat-error>

        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">{{
            replacementValueLabel
          }}</mat-label>
          <input
            matInput
            spellcheck="false" maxlength="12"
            formControlName="replacementValue"
            (blur)="logErrors()"
          />
          <mat-error *ngIf="formErrors['replacementValue']">{{
            formErrors["replacementValue"]
          }}</mat-error>
        </mat-form-field>

        <p>{{ anyOtherDamageQuestion }}</p>
        <section class="row-div modified_checkbox" formGroupName="extraDamage">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes5Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo5Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </section>
        <mat-error *ngIf="formGroupErrors['extraDamage']">{{
          formGroupErrors["extraDamage"]
        }}</mat-error>

        <mat-form-field
          appearance="outline"
          class="form-select"
          floatLabel="always"
          *ngIf="
            motorForm.controls['extraDamage'].controls['yes'].value === true
          "
        >
          <mat-label class="form-select-placeholder-unselected">{{'Damage Details'}}</mat-label>
          <textarea matInput
            placeholder="{{ damageDetailsText }}"
            formControlName="extraDamageText"
            (blur)="logErrors()"
            style="height: 70px;" ></textarea>
          <mat-error *ngIf="motorForm.controls['extraDamage'].controls['yes'].value === true && formErrors['extraDamageText']">{{
            formErrors["extraDamageText"]
          }}</mat-error>
        </mat-form-field>
      </div>

      <div class="width-100pc" *ngIf="claim === 'theft'">
        <p>{{ soleOwnerQuestion }}</p>
        <section class="row-div modified_checkbox" formGroupName="soleOwner">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes12Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo12Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </section>
        <mat-error *ngIf="formGroupErrors['soleOwner']">{{
          formGroupErrors["soleOwner"]
        }}</mat-error>

        <div
          class="width-100pc"
          *ngIf="motorForm.controls['soleOwner'].controls['no'].value === true"
        >
          <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">{{
              previousOwnerLabel
            }}</mat-label>
            <input
              matInput
              formControlName="previousOwner"
              (blur)="logErrors()"
            />
            <mat-error *ngIf="formErrors['previousOwner']">{{
              formErrors["previousOwner"]
            }}</mat-error>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="form-select"
            appFullYearDateFormat
          >
            <mat-label class="form-select-placeholder-unselected">{{
              purchaseDateLabel
            }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="pickerS"
              readonly="true"
              (click)="pickerS.open()"
              formControlName="purchaseDate"
              (blur)="logErrors()"
            />
            <mat-error *ngIf="formErrors['purchaseDate']">{{
              formErrors["purchaseDate"]
            }}</mat-error>
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerS"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerS> </mat-datepicker>
          </mat-form-field>
        </div>

        <p>{{ hpInterestQuestion }}</p>
        <section class="row-div modified_checkbox" formGroupName="hpInterest">
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes13Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo13Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </section>
        <mat-error *ngIf="formGroupErrors['hpInterest']">{{
          formGroupErrors["hpInterest"]
        }}</mat-error>

        <div
          class="width-100pc"
          *ngIf="
            motorForm.controls['hpInterest'].controls['yes'].value === true
          "
        >
          <mat-form-field appearance="outline" class="form-select" floatLabel="always">
            <mat-label class="form-select-placeholder-unselected">{{'Hire purchase interest?'}}</mat-label>
            <textarea
              matInput
              placeholder="{{ hpInterestLabel }}"
              formControlName="hpDetails"
              (blur)="logErrors()"
              style="height: 70px;"
            ></textarea>
            <mat-error *ngIf="formErrors['hpDetails']">{{
              formErrors["hpDetails"]
            }}</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div
        class="row-div margin-top-50 margin-bottom-40"
        *ngIf="altView === true && type !== 'no-rep'"
      >
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{ cancelText }}</span>
        </button>
        <button mat-button type="submit" [disabled]="!motorForm.valid">
          <span class="button-text">{{ saveText }}</span>
        </button>
      </div>
    </div>

    <div class="card-section bottom-section" *ngIf=" additionalInfo === false && claim === 'entertainment' && type === 'no-rep'" >
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          fullNameAltLabel
        }}</mat-label>
        <input matInput formControlName="ownerName" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['ownerName']">{{
          formErrors["ownerName"]
        }}</mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        appFullYearDateFormat
      >
        <mat-label class="form-select-placeholder-unselected">{{
          dateLabel
        }}</mat-label>
        <input
          matInput
          [min]="maxDate"
          [max]="maxDate"
          [matDatepicker]="picker"
          readonly="true"
          (click)="picker.open()"
          formControlName="date"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker> </mat-datepicker>
      </mat-form-field>

      <div class="simple_checkbox width-100pc margin-bottom-40 margin-top-30">
        <mat-checkbox formControlName="iSwear" (blur)="logErrors()" style="margin-bottom: 10px;">
          <p class="checkbox-p" [innerHTML]="iSwearText | dompurify"></p>
        </mat-checkbox>
        <mat-error *ngIf="formErrors['iSwear']">
          {{formErrors["iSwear"]}}
        </mat-error>
      </div>

      <div class="row-div margin-bottom-24 margin-top-30">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{ cancelText }}</span>
        </button>
        <button mat-button type="submit" [disabled]="(motorForm.controls['iSwear'].value === false || !motorForm.valid)">
          <span class="button-text">{{ saveText }}</span>
        </button>
      </div>
    </div>

    <div class="card-section bottom-section" *ngIf=" additionalInfo === true && motorForm.controls['driver'].controls['isElseOne'].value === true" >
      <h2>{{ additionalInfoHeading }}</h2>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          driverRelationshipLabel
        }}</mat-label>
        <input
          matInput
          formControlName="driverRelationship"
          (blur)="logErrors()"
        />
        <mat-error *ngIf="formErrors['driverRelationship']">{{
          formErrors["driverRelationship"]
        }}</mat-error>
      </mat-form-field>

      <p>{{ serviceQuestion }}</p>

      <div class="row-div modified_checkbox" ></div>

      <section formGroupName="driverInService" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes6Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo6Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </div>

        <mat-error *ngIf="formGroupErrors['driverInService']">{{
          formGroupErrors["driverInService"]
        }}</mat-error>
      </section>

      <mat-form-field appearance="outline" class="form-select"
        *ngIf="motorForm.controls['driverInService'].controls['yes'].value === true "
      >
        <mat-label class="form-select-placeholder-unselected">{{
          serviceYearsLabel
        }}</mat-label>
        <input matInput type="text" maxlength="2" formControlName="driverServiceYears" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['driverServiceYears']">{{
          formErrors["driverServiceYears"]
        }}</mat-error>
      </mat-form-field>


      <p>{{ driverYearsQuestion }}</p>
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          numOfYearsLabel
        }}</mat-label>
        <input matInput type="text" maxlength="2" formControlName="driverYears" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['driverYears']">{{
          formErrors["driverYears"]
        }}</mat-error>
      </mat-form-field>

      <p>{{ blameGameQuestion }}</p>
      <section formGroupName="driverBlame" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes8Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo8Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </div>
        
        <mat-error *ngIf="formGroupErrors['driverBlame']">
          {{formGroupErrors["driverBlame"]}}
        </mat-error>
      </section>

      <p>{{ admitLiabilityQuestion }}</p>
      <section formGroupName="driverAdmitLiability" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes9Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo9Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </div>
        
        <mat-error *ngIf="formGroupErrors['driverAdmitLiability']">
          {{formGroupErrors["driverAdmitLiability"]}}
        </mat-error>
      </section>

      <p>{{ previousAccQuestion }}</p>
      <section formGroupName="previousAccident" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes7Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo7Change()">
              {{noText}}
            </mat-checkbox>
          </div>
        </div>
        
        <mat-error *ngIf="formGroupErrors['previousAccident']">
          {{formGroupErrors["previousAccident"]}}
        </mat-error>
      </section>

      <div
        *ngIf="
          motorForm.controls['previousAccident'].controls['yes'].value === true
        "
        class="width-100pc"
      >
        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">{{
            numOfAccidentsLabel
          }}</mat-label>
          <input
            matInput
            formControlName="accidentNumber"
            (blur)="logErrors()"
          />
          <mat-error *ngIf="formErrors['accidentNumber']">{{
            formErrors["accidentNumber"]
          }}</mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="form-select"
          appFullYearDateFormat
        >
          <mat-label class="form-select-placeholder-unselected">{{
            dateAccidentLabel
          }}</mat-label>
          <input
            matInput
            [min]="minLossDate"
            [max]="maxDate"
            [matDatepicker]="pickerA"
            readonly="true"
            (click)="pickerA.open()"
            formControlName="dateAccident"
            (blur)="logErrors()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerA"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerA> </mat-datepicker>
          <mat-error *ngIf="formErrors['dateAccident']">{{formErrors['dateAccident']}}</mat-error>
        </mat-form-field>
      </div>

      <p>{{ convictionQuestion }}</p>
      <section formGroupName="driverConvicted" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox formControlName="yes" (change)="onYes10Change()">{{
              yesText
            }}</mat-checkbox>
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox formControlName="no" (change)="onNo10Change()">{{
              noText
            }}</mat-checkbox>
          </div>
        </div>
        
        <mat-error *ngIf="formGroupErrors['driverConvicted']">
          {{formGroupErrors["driverConvicted"]}}
        </mat-error>
      </section>

      <div
        *ngIf="
          motorForm.controls['driverConvicted'].controls['yes'].value === true
        "
        class="width-100pc"
      >
        <mat-form-field appearance="outline" class="form-select" floatLabel="always">
          <mat-label class="form-select-placeholder-unselected">{{'Conviction Details'}}</mat-label>
          <textarea matInput
            formControlName="convictionsDetails"
            placeholder="{{ convictionDetailsLabel }}"
            style="height: 70px;" (blur)="logErrors()"></textarea>

          <input
            matInput
            formControlName="convictionsDetails"
            (blur)="logErrors()"
          />
          <mat-error *ngIf="formErrors['convictionsDetails']">{{
            formErrors["convictionsDetails"]
          }}</mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="form-select"
          appFullYearDateFormat
        >
          <mat-label class="form-select-placeholder-unselected">{{
            dateConvictionLabel
          }}</mat-label>
          <input
            matInput
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="pickerB"
            readonly="true"
            (click)="pickerB.open()"
            formControlName="dateConviction"
            (blur)="logErrors()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerB"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerB> </mat-datepicker>
          <mat-error *ngIf="formErrors['dateConviction']">{{formErrors['dateConviction']}}</mat-error>
        </mat-form-field>
      </div>

      <p>{{ licenceTypeQuestion }}</p>
      <section formGroupName="driverLicense" style="margin-bottom: 15px;">
        <div class="row-div modified_checkbox" >
          <div class="row-inner-div row-inner-div-left">
            <mat-checkbox
              formControlName="full"
              (change)="onFullLicenseChange()"
              >{{ fullText }}</mat-checkbox
            >
          </div>
          <div class="row-inner-div row-inner-div-right">
            <mat-checkbox
              formControlName="provisional"
              (change)="onProvLicenceChange()"
              >{{ provisionalText }}</mat-checkbox
            >
          </div>
        </div>
        
        <mat-error *ngIf="formGroupErrors['driverLicense']">
          {{formGroupErrors["driverLicense"]}}
        </mat-error>
      </section>

      <mat-form-field
        appearance="outline"
        class="form-select"
        appFullYearDateFormat
      >
        <mat-label class="form-select-placeholder-unselected">{{
          dateFirstDrivingLabel
        }}</mat-label>
        <input
          matInput
          [min]="minDate"
          [max]="maxDate"
          [matDatepicker]="pickerC"
          readonly="true"
          (click)="pickerC.open()"
          formControlName="datePassDriving"
          (blur)="logErrors()"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerC"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerC> </mat-datepicker>
        <mat-error *ngIf="formErrors['datePassDriving']">{{formErrors['datePassDriving']}}</mat-error>
      </mat-form-field>

      <p>{{ ownMotorVehicleQuestion }}</p>
      <section class="row-div modified_checkbox" formGroupName="driverHasMotor">
        <div class="row-inner-div row-inner-div-left">
          <mat-checkbox formControlName="yes" (change)="onYes11Change()">{{
            yesText
          }}</mat-checkbox>
        </div>
        <div class="row-inner-div row-inner-div-right">
          <mat-checkbox formControlName="no" (change)="onNo11Change()">{{
            noText
          }}</mat-checkbox>
        </div>
      </section>
      <mat-error *ngIf="formGroupErrors['driverHasMotor']">{{
        formGroupErrors["driverHasMotor"]
      }}</mat-error>

      <div
        *ngIf="
          motorForm.controls['driverHasMotor'].controls['yes'].value === true
        "
        class="width-100pc"
      >
        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">{{
            insurerNameLabel
          }}</mat-label>
          <input matInput formControlName="insurerName" (blur)="logErrors()" />
          <mat-error *ngIf="formErrors['insurerName']">{{
            formErrors["insurerName"]
          }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">{{
            insurerAddressLabel
          }}</mat-label>
          <input
            matInput
            formControlName="insurerAddress"
            (blur)="logErrors()"
          />
          <mat-error *ngIf="formErrors['insurerAddress']">{{
            formErrors["insurerAddress"]
          }}</mat-error>
        </mat-form-field>
      </div>

      <div class="row-div margin-bottom-40 margin-top-30">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{ cancelText }}</span>
        </button>
        <button mat-button type="submit" [disabled]="!motorForm.valid">
          <span class="button-text">{{ saveText }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
